// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { CircleMinus as RawCircleMinus } from "lucide-react";
export const CircleMinus = /* @__PURE__ */ createIcon(RawCircleMinus, "CircleMinus", 2);
